import React, { useEffect, useRef, useState } from 'react'

import TimeWindowDropdown from './TimeWindowDropdown'
import ChartControls from './ChartControls'
import NitrateChart from './NitrateChart'
import ChartTabs from './ChartTabs'

const DetailChart = () => {
    const chartRef = useRef(null)
    const chartHeaderRef = useRef(null)
    const [headerHeight, setHeaderHeight] = useState(0)

    useEffect(() => {
        if (!chartHeaderRef.current) return

        const updateHeaderHeight = () => {
            setHeaderHeight(chartHeaderRef.current.offsetHeight || 0)
        }

        updateHeaderHeight()

        const resizeObserver = new ResizeObserver(updateHeaderHeight)
        resizeObserver.observe(chartHeaderRef.current)

        return () => {
            if (chartHeaderRef.current) {
                resizeObserver.unobserve(chartHeaderRef.current)
            }
        }
    }, [])

    return (
        <div>
            <div ref={chartHeaderRef} style={{ paddingBottom: 20 }}>
                <ChartTabs />
                <ChartControls chartRef={chartRef} />
                <TimeWindowDropdown />
            </div>
            <div ref={chartRef} className={'chart'}>
                <NitrateChart headerHeight={headerHeight} />
            </div>
        </div>
    )
}

export default DetailChart
